import { render, staticRenderFns } from "./norecord.vue?vue&type=template&id=0ba7bead&"
import script from "./norecord.vue?vue&type=script&lang=js&"
export * from "./norecord.vue?vue&type=script&lang=js&"
import style0 from "./norecord.vue?vue&type=style&index=0&id=0ba7bead&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports